import script from "./dynamicSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./dynamicSwiper.vue?vue&type=script&setup=true&lang=ts"

import "./dynamicSwiper.vue?vue&type=style&index=0&id=f87748f8&lang=css"

const __exports__ = script;

export default __exports__